const stringReplace = {
    strings: document.querySelectorAll('.jsStringReplace') as NodeListOf<HTMLElement>, 

    init() {
       this.replaceStrings();
      
    },
    replaceStrings() {
        this.strings.forEach((item)=>{    
            const string = item.dataset.string as string     
             item.innerText = string.replaceAll('_', ' ');
           
        });
    }

}

export default stringReplace;